export const API_VERSION = 'v1';

export const getClientID = () => 'frontend';

// This function will determine the boominstance base URL depending on the build environment
export const getDefaultAPIBaseURL = () => process.env.REACT_APP_API_URL || 'https://api.sales.skillschecker.b52.cloud';

export const getEnvironment = () => {
  const hostname = window.location.hostname; // TODO workaround: change with env variable
  const subdomain = hostname.split('.')[0];
  if (subdomain === 'localhost') {
    return 'sales';
  }
  return subdomain;
};

export const isMyliaEnvironment = process.env.REACT_APP_IS_MYLIA === 'true' || getEnvironment() === 'aim';

export const LANGUAGE_LOCAL_MAP = {
  ITALIAN: {
    key: 'it',
    momentLocale: 'it',
    translation: 'it',
    backend: 'ITALIAN'
  },
  ENGLISH: {
    key: 'en',
    momentLocale: 'en',
    translation: 'en',
    backend: 'ENGLISH'
  }
};

export const INSTITUTION_TYPES = {
  SMARTWORKING: 'SMARTWORKING'
};

export const LANGUAGE_BACKEND_MAP = {
  it: 'ITALIAN',
  en: 'ENGLISH'
};

export const ACCESS_RULES_TYPES = {
  DEFAULT: 'DEFAULT',
  USER: 'USER'
};

export const USER_ROLES = {
  ROOT: 'ROOT',
  ADMIN: 'ADMIN',
  SUPERVISOR: 'SUPERVISOR',
  USER: 'USER',
  PRINCIPAL: 'PRINCIPAL'
};

export const SKILLS_INSTRUCTION_LINKS = {
  REGULAR: {
    en: 'https://www.edulai.com/understand-the-results',
    it: 'https://www.edulai.com/capire-i-risultati'
  },
  SMARTWORKING: {
    en: 'https://www.edulai.com/smart-working-instructions',
    it: 'https://www.edulai.com/smart-working-instructions'
  }
};

export const PERMISSIONS = {
  READ: 'READ',
  CREATE: 'CREATE',
  DELETE: 'DELETE',
  UPDATE: 'UPDATE',
  EXTEND: 'EXTEND',
  REACTIVATE: 'REACTIVATE',
  ASK: 'ASK'
};

export const PERMISSION_ENTITIES = {
  USER: 'USER',
  DOMAIN: 'DOMAIN',
  QUIZ: 'QUIZ',
  QUESTION: 'QUESTION',
  SUBMISSION: 'SUBMISSION',
  ANSWER: 'ANSWER',
  SKILL: 'SKILL',
  ANALYTICS: 'ANALYTICS',
  AI: 'AI'
};

export const SUBMISSION_STATUS_TYPES = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED'
};

export const QUIZ_STATUS_TYPES = {
  DRAFT: 'DRAFT',
  RUNNING: 'RUNNING',
  PAUSED: 'PAUSED',
  DONE: 'DONE',
  READY: 'READY',
  ALL: 'ALL',
  EXPIRED_FOR_USER: 'EXPIRED_FOR_USER'
};

export const PRIVACY_POLICY_LINKS = {
  en: 'https://www.edulai.com/privacy-policy',
  it: 'https://it.edulai.com/privacy-policy'
};

export const SKILLS_MAP_SALES = {
  CRITICAL_THINKING: '74',
  PROBLEM_SOLVING: '4',
  LEARNING: '7',
  RESULT_ORIENTATION: '1',
  ASSERTIVENESS: '6',
  RESILIENCE: '59',
  COLLABORATION: '63',
  COMMUNICATION: '3',
  LEADERSHIP: '78'
};

export const SKILLS_MAP_SW = {
  DIGITAL_COLLABORATION: '70',
  DIGITAL_COMMUNICATION: '52',
  DIGITAL_PROBLEM_SOLVING: '78',
  DIGITAL_LEADERSHIP: '64',
  AUTONOMY: '58',
  PROACTIVITY: '102',
  ASSERTIVENESS: '85',
  EMPATY: '97',
  RESILIENCE: '107',
  DIGITAL_TECHNOLOGY: '90'
};

export const SKILLS_MAP_STAGING = {
  COLLABORATION: '2',
  PROBLEM_SOLVING: '4',
  LEADERSHIP: '5',
  COMMUNICATION: '3',
  INTERCULTURALITY: '6',
  LEARNING: '7',
  CRITICAL_THINKING: '1'
};

export const ALL_SKILLS_MAP = {
  CRITICAL_THINKING: 'Pensiero critico',
  PROBLEM_SOLVING: 'Problem solving',
  LEARNING: 'Apprendimento',
  RESULT_ORIENTATION: 'Orientamento al risultato',
  ASSERTIVENESS: 'Assertività',
  RESILIENCE: 'Resilienza',
  COLLABORATION: 'Collaborazione',
  COMMUNICATION: 'Comunicazione',
  LEADERSHIP: 'Leadership',
  DIGITAL_COLLABORATION: 'Collaborazione digitale',
  DIGITAL_COMMUNICATION: 'Comunicazione digitale',
  DIGITAL_PROBLEM_SOLVING: 'Problem Solving Digitale',
  DIGITAL_LEADERSHIP: 'Leadership Digitale',
  AUTONOMY: 'Autonomia',
  PROACTIVITY: 'Proattività',
  EMPATY: 'Empatia',
  DIGITAL_TECHNOLOGY: 'Utilizzo delle Tecnologie Digitali',
  INTERCULTURALITY: 'Interculturalità'
};

export const SKILLS_MAP = {
  sales: SKILLS_MAP_SALES,
  smartworking: SKILLS_MAP_SW,
  staging: SKILLS_MAP_STAGING
};
